import { create } from "zustand";

/** Unsubmitted a2ui form input, keyed by `UiRenderer`'s principal-scoped render
    key. Holds typed clinical text, so entries must not outlive their author. */
interface UiModelState {
  models: Record<string, Record<string, unknown>>;
  submitting: Record<string, boolean>;
  init: (renderId: string, initial?: Record<string, unknown>) => void;
  set: (renderId: string, bind: string, value: unknown) => void;
  reset: (renderId: string) => void;
  setSubmitting: (renderId: string, value: boolean) => void;
  clearAll: () => void;
}

export const useUiModelStore = create<UiModelState>((set) => ({
  models: {},
  submitting: {},
  init: (renderId, initial = {}) =>
    set((s) =>
      s.models[renderId] ? s : { models: { ...s.models, [renderId]: initial } },
    ),
  set: (renderId, bind, value) =>
    set((s) => ({
      models: {
        ...s.models,
        [renderId]: { ...s.models[renderId], [bind]: value },
      },
    })),
  // Re-seed on next `init`, else a same-card refresh (ask_changes) keeps the submitted text.
  reset: (renderId) =>
    set((s) => {
      const { [renderId]: _drop, ...rest } = s.models;
      return { models: rest };
    }),
  setSubmitting: (renderId, value) =>
    set((s) => ({
      submitting: { ...s.submitting, [renderId]: value },
    })),
  // A card left mid-flight would otherwise stay disabled for the next principal.
  clearAll: () => set({ models: {}, submitting: {} }),
}));
